import { apiInstance } from './api';

/**
 * Get / save config data
 */
export const getConfigData = async (configId: string) =>
  apiInstance.get(`/configs/${configId}`);
